<template>
  <v-container fluid class="home-redirect-logo-wrap">
    <v-layout column align-center justify-center fill-height>
      <img src="@/assets/logo.png" style="width: 350px;" alt="SmartTransit" class="mb-5">
    </v-layout>
  </v-container>
</template>

<style scoped>
.home-redirect-logo-wrap {
  min-height: calc(100vh - 56px);
}
</style>

<script>
import src from './src'
export default src
</script>
